
'use strict';
(function () {
    angular
        .module('flightPunctuality')
        .component('viewFlightPunctualityGridComponent', {
            templateUrl: 'flight-punctuality/components/view-flight-punctuality-grid-all-in-one.tpl.html',
            controller: function ($timeout, $window ,CommonMasterData, ContextMenuService,FlightPunctualityService, EventManagerService, PopupManager, MessageService, FlightWatch) {
                var vm = this;
                vm.selectedRow = null;
                vm.showResults = false;
                vm.dataRowList = [];
                vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);
                vm.masterLists = {};

              vm.model = {
                selectedRowDataDTO:[],
                relatedAirCraft : [],
                airports: [],
                approachTypes:[],
                delayCodeDetails:[],
                fuelSuppliers:[],
                masterList : {
                  airportList : [],
                  crewTypes : [],
                  profileTT : [],
                  delayCodesTT : [],
                  canvasHeight : 0,
                  canvasWidth : 0,
                  fromDateFormatInvalid : false,
                  toDateFormatInvalid : false,
                  fromDateAfterToDate : false,
                  tab : 1,
                },
                searchCriteria : {
                  fromDate : moment().format('DD/MM/YYYY'),
                  toDate : moment().format('DD/MM/YYYY'),
                  fromTime : moment().format('HH:MI'),
                  toTime : moment().format('HH:MI'),
                  origin : null,
                  destination : null,
                  status : null,
                  flightNo : null,
                  pageSize : 150,
                  startPosition : 1
                },
                searchPanelToggle : true,
                depaturePanelToggle : true,
                arrivalPanelToggle : true,
                interPanelToggle : true,
                flightData : {
                  departureFlights : [],
                  arrivalFlights : [],
                  intermediateFlights : [],
                  totalRecords : null,
                }
              };

                vm.clickOnRow = function (event, index, rowContent, flag) {
                    var passParams = {'selectedRowData':rowContent, flag:flag};
                    vm.selectedRow = index;

                    vm.selectARow(passParams);
                    if(!angular.isUndefined(event)){

                    }
                };
              vm.getContextMenuContent = function (type , rowData) {
                vm.model.selectedRowDataDTO = rowData;
                return ContextMenuService.getContextMenu('DELAY_CODE');

              };

                vm.$onChanges = function (changeObj) {
                    if(changeObj.gridData && changeObj.gridData &&
                        (changeObj.gridData.currentValue !== changeObj.gridData.previousValue)){
                        vm.dataRowList=[];
                        $timeout(function () {
                            vm.dataRowList = changeObj.gridData.currentValue;
                            vm.selectedRow = null;
                            vm.showResults = true;
                        },10);
                    }
                    if(changeObj.masterDataLists && changeObj.masterDataLists &&
                            (changeObj.masterDataLists.currentValue !== changeObj.masterDataLists.previousValue)){
                            $timeout(function () {
                                vm.masterLists = changeObj.masterDataLists.currentValue;
                            },0)
                    }

                    if(changeObj.selectedRowData && changeObj.selectedRowData &&
                        (changeObj.selectedRowData.currentValue !== changeObj.selectedRowData.previousValue)){
                        if(!angular.isUndefined(vm.selectedRowData) && !angular.isUndefined(vm.primaryKey) && vm.selectedRowData!==null){
                            $timeout(function () {
                                var selectedIndex = _.findIndex(vm.dataRowList, function(item){
                                    return changeObj.selectedRowData.currentValue[vm.primaryKey] === item[vm.primaryKey];
                                });
                                if (!angular.isUndefined(selectedIndex)){
                                    vm.selectedRow = selectedIndex;
                                    var passParams = {'selectedRowData':vm.dataRowList[vm.selectedRow], flag:'row'};
                                    vm.selectARow(passParams);
                                }
                            },0);
                        }
                    }
                };

                angular.element($window).bind('resize', function(){
                    $timeout(function () {
                        vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);
                    },0);
                });
            },
            bindings: {
                gridData: '<',
                rowInlineEditOptions: '<',
                selectARow: '&',
                masterDataLists: '<',
                selectedRowData: '<',
                primaryKey: '@'
            }
        });
})();
